window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function gtag() {
  window.dataLayer.push(arguments);
};

window.gtag("js", new Date());
window.gtag("config", "G-RVCXBFJT7R");

window.nagayuTrack = function nagayuTrack(eventName, params = {}) {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params);
  }
};

try {
  const isEmbedded = window.self !== window.top || new URLSearchParams(window.location.search).has("embed");
  if (isEmbedded) {
    document.documentElement.classList.add("embedded-admin");
  }
} catch {
  document.documentElement.classList.add("embedded-admin");
}
